export default __webpack_public_path__ + "static/media/grafema_capitolio_13.8037e421.jpg";